module.exports = __webpack_public_path__ + "static/media/help.f2fa34f2.png";